import api from '@/lib/api';

export async function downloadPost(path, body, filename) {
  // Exports (Excel/PDF) can take longer to generate than a normal API call.
  const res = await api.post(path, body, { responseType: 'blob', timeout: 120_000 });
  triggerDownload(res.data, filename);
}

export async function downloadGet(path, filename, params) {
  const res = await api.get(path, { responseType: 'blob', timeout: 120_000, params });
  triggerDownload(res.data, filename);
}

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
